import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'lib-button',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  template: `<!-- <Common Button with spinner> -->
    <button
      [ngClass]="getBgClass()"
      class="font-bold text-md rounded-md px-3 h-11 flex items-center justify-center relative"
      [disabled]="disabled || loadingSpinner"
      (click)="onClick($event)"
      (mouseover)="mouseHover(imgURL ? imgURL : '')"
      (mouseleave)="imgURL ? (imgHoverCheck = false) : ''"
    >
      @if(loadingSpinner && !isAction){
      <span class="absolute inset-0 flex items-center justify-center">
        <svg
          class="animate-spin h-5 w-5 text-primary"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </span>
      }
      @if(loadingSpinner && isAction){
      <span class="flex items-center justify-center w-full h-full">
        <mat-spinner [diameter]="24"></mat-spinner>
      </span>
      } @else {
      <span class="flex items-center gap-2 tracking-wider">
        @if(iconName){
        <mat-icon *ngIf="iconName">{{ iconName }}</mat-icon>
        } @else if(imgURL && !disabled && !loadingSpinner){
        <img
          src="{{ imgHoverCheck ? imgHoverURL : imgURL }}"
          alt="icons"
          width="25"
        />
        }
        @if(label){ <span class="hidden md:inline">
          {{ label }}
        </span>
        }
      </span>
      }
    </button> `,
  styles: [],
})
export class ButtonComponent {
  @Input() label?: string;
  @Input() disabled: boolean = false;
  @Input() btnType: 'normal' | 'limitedcustomize' | 'transparent' | 'cancel' = 'normal';
  @Input() iconName!: string;
  @Input() imgURL!: string;
  @Input() isAction: boolean = false;
  @Output() clicked = new EventEmitter<MouseEvent>();
  @Input() customstyleclass: string = 'bg-e-support-10 text-[#b3b4b7]';
  public imgHoverCheck: boolean = false;
  public imgHoverURL!: string;

  @Input() loadingSpinner: boolean = false;
  // Style based on the type
  public getBgClass(): string[] {
    if (this.disabled || this.loadingSpinner) {
      return ['bg-e-support-10', 'text-[#b3b4b7]'];
    }

    switch (this.btnType) {
      case 'transparent':
        return [
          'bg-transparent',
          'text-mdPrimary-500',
          'border-2',
          'border-solid',
          'border-mdPrimary-500',
          'hover:bg-mdPrimary-500',
          'hover:text-e-white-text',
        ];
      case 'normal':
        return ['bg-mdPrimary-500', 'text-e-white-text', 'hover:bg-secondary'];
      case 'cancel':
        return [
          'bg-e-support-10',
          'text-e-black-text',
          'hover:bg-hovere-support-10',
        ];
      case 'limitedcustomize':
        return this.customstyleclass.trim().split(/\s+/);
      default:
        return ['bg-e-support-10', 'text-[#b3b4b7]'];
    }
  }

  public onClick(event: MouseEvent): void {
    //  this.loadingSpinner = true;
    this.clicked.emit(event);
    event.stopPropagation();
  }

  public mouseHover(url: string) {
    this.imgHoverCheck = true;
    if (url !== '') {
      let result = url.split('/');
      this.imgHoverURL = `/public/images/hover_${result[3]}`;
    }
  }
}
